import React, { useState } from "react";
import styles from "./Table.module.css";
import whatsappIcon from "../../assets/image 63.png";
import { useSelector } from "react-redux";

function DistributorTable(props) {
  const [selectedRow, setSelectedRow] = useState(null);

  const accountType = useSelector(
    (state) => state.userData.loginData.account_type
  );

  const handleRowClick = (index) => {
    if (selectedRow === index) {
      setSelectedRow(null);
    } else {
      setSelectedRow(index);
    }
  };

  // const handleUserPin = (data) => {
  //   props.setPinId(data);
  // };

  return (
    <div>
      <div className={styles.table_header}>
        <div className={styles.table_column}>
          <p>S/N</p>
        </div>
        <div className={styles.table_column}>
          {accountType === "DISTRIBUTOR" ? (
            <p>
              {props.table_type === "customers"
                ? "Name"
                : props.table_type === "pin"
                ? accountType === "DISTRIBUTOR"
                  ? "Buyer"
                  : "Seller"
                : props.debit
                ? props.credit
                  ? "Transaction ID"
                  : "Name"
                : "Transact ID"}
            </p>
          ) : (
            <p>
              {props.table_type === "customers"
                ? "Name"
                : props.table_type === "pin"
                ? props.sold
                  ? "Seller"
                  : "Buyer"
                : "Transact ID"}
            </p>
          )}
        </div>
        <div className={styles.table_column}>
          <p>
            {props.table_type === "customers"
              ? "Pins"
              : props.table_type === "pin"
              ? "Platform"
              : "Amount"}
          </p>
        </div>
        <div className={styles.table_column}>
          <p>
            {props.table_type === "customers"
              ? "Orders"
              : props.table_type === "pin"
              ? "Amount"
              : "Type"}
          </p>
        </div>
        <div className={styles.table_column}>
          <svg
            width="4"
            height="17"
            viewBox="0 0 4 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.64783 2.47626C2.64783 2.83207 2.3594 3.12049 2.00361 3.12049C1.64781 3.12049 1.35938 2.83206 1.35938 2.47626C1.35938 2.12046 1.64781 1.83203 2.00361 1.83203C2.3594 1.83203 2.64783 2.12046 2.64783 2.47626ZM2.64789 14.5203C2.64789 14.8761 2.35946 15.1645 2.00366 15.1645C1.64786 15.1645 1.35943 14.8761 1.35943 14.5203C1.35943 14.1645 1.64786 13.876 2.00366 13.876C2.35947 13.876 2.64789 14.1645 2.64789 14.5203ZM2.64783 8.52025C2.64783 8.87605 2.3594 9.16448 2.00361 9.16448C1.64781 9.16448 1.35938 8.87605 1.35938 8.52025C1.35938 8.16445 1.64781 7.87602 2.00361 7.87602C2.3594 7.87602 2.64783 8.16445 2.64783 8.52025Z"
              stroke="#36363E"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </div>
      </div>

      <div className={styles.table_inner}>
        {(props?.tableData?.data || props?.tableData)?.map((data, index) => (
          <div className={styles.table_header_wrapper}>
            <div
              key={index}
              className={styles.table_header}
              onClick={() => {
                // handleUserPin(data);
                // props.setPinId(data);
                handleRowClick(index);
              }}
            >
              <div className={styles.table_column}>
                <p>{index + 1}</p>
              </div>
              <div className={styles.table_column}>
                {!props.debit ? (
                  <p>
                    {props?.table_type === "customers"
                      ? data?.fullname
                      : data?.ref_id ||
                        data?.buyer_details?.fullname ||
                        data?.seller_details?.fullname}
                  </p>
                ) : (
                  <p>{data?.user?.fullname || data?.ref_id}</p>
                )}
              </div>
              <div className={styles.table_column}>
                <p>
                  {props?.table_type === "customers"
                    ? Object.values(data?.grouped_pins || {})
                        .reduce((acc, pins) => acc + pins.length, 0)
                        .toLocaleString()
                    : props.table_type === "pin"
                    ? data?.platform
                    : Number(data?.amount)?.toLocaleString()}
                </p>
              </div>
              <div className={styles.table_column}>
                <p>
                  {props?.table_type === "customers"
                    ? data?.sales?.length
                    : data?.payment_type ||
                      data?.details?.length ||
                      data?.export_details?.length ||
                      data?.platform}
                </p>
              </div>
              <div className={styles.table_column}>
                {props.table_type === "customers" ? (
                  <img
                    src={whatsappIcon}
                    onClick={() => {
                      props.setSendExpiryModalData(data);
                      props.setSendExpiryModal(true);
                    }}
                    alt="whatsapp"
                    style={{
                      width: "30px",
                      height: "30px",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <svg
                    width="4"
                    height="17"
                    viewBox="0 0 4 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.64783 2.47626C2.64783 2.83207 2.3594 3.12049 2.00361 3.12049C1.64781 3.12049 1.35938 2.83206 1.35938 2.47626C1.35938 2.12046 1.64781 1.83203 2.00361 1.83203C2.3594 1.83203 2.64783 2.12046 2.64783 2.47626ZM2.64789 14.5203C2.64789 14.8761 2.35946 15.1645 2.00366 15.1645C1.64786 15.1645 1.35943 14.8761 1.35943 14.5203C1.35943 14.1645 1.64786 13.876 2.00366 13.876C2.35947 13.876 2.64789 14.1645 2.64789 14.5203ZM2.64783 8.52025C2.64783 8.87605 2.3594 9.16448 2.00361 9.16448C1.64781 9.16448 1.35938 8.87605 1.35938 8.52025C1.35938 8.16445 1.64781 7.87602 2.00361 7.87602C2.3594 7.87602 2.64783 8.16445 2.64783 8.52025Z"
                      stroke="#36363E"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                )}
              </div>
            </div>
            {selectedRow === index && (
              <div className={styles.row_details}>
                <div className={styles.row_details_time}>
                  <h1>
                    {props.pin ? "Pin - " : ""}{" "}
                    {
                      // props?.table_type === "customers"
                      //   ? data?.fullname
                      //   :
                      data?.created_at?.slice(0, 10) || props.pin
                    }
                  </h1>
                  <div>
                    {props?.table_type === "customers" ? (
                      <p
                        onClick={() => {
                          props.setFundAgentModal(true);
                          props.setFixedAgentId(data.id);
                        }}
                      >
                        Fund Agent
                      </p>
                    ) : (
                      <p>{data?.created_at?.slice(11)}</p>
                    )}
                  </div>
                </div>
                <div
                  className={
                    data?.payment_status?.toLowerCase() !== "success"
                      ? styles.row_details_status_error
                      : styles.row_details_status
                  }
                >
                  {props?.table_type === "customers" ? (
                    <button
                      onClick={() => {
                        props.setFundAgentDataModal(true);
                        props.setFixedAgentData(data);
                      }}
                      style={{
                        padding: "8px 16px",
                        backgroundColor: "#1814F3",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "500",
                        transition: "all 0.2s ease",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        width: "auto",
                      }}
                    >
                      View Agent's Info
                    </button>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                        width: "100px",
                        height: "auto",
                      }}
                    >
                      {props.sold && (
                        <p>
                          {data?.export_details?.[0]?.pin
                            ? "Exported Pin: " + data?.export_details?.[0]?.pin
                            : "Amount: " + data?.details?.length}
                        </p>
                      )}
                      <p>
                        {props.debit ? "Amount: ₦" : "Invoice Amount: ₦"}
                        {props.debit
                          ? data.amount?.toLocaleString()
                          : data?.total_amount?.toLocaleString()}
                      </p>
                      {!props.debit ? (
                        <>
                          <p>Paid: ₦{data?.amount_paid?.toLocaleString()}</p>
                          <p>
                            Balance: ₦
                            {(
                              data?.total_amount - data?.amount_paid
                            )?.toLocaleString()}
                          </p>
                        </>
                      ) : (
                        <>
                          <p style={{ wordBreak: "break-all" }}>
                            Date:
                            <br /> {data?.created_at?.split(" ")[0]}
                          </p>
                          <p style={{ wordBreak: "break-all" }}>
                            Ref ID:
                            <br /> {data?.ref_id}
                          </p>
                        </>
                      )}
                      <p>{data?.payment_status || ""}</p>
                      {data.payment_status.toLowerCase() !== "full payment" &&
                        props.sold &&
                        accountType === "DISTRIBUTOR" && (
                          <button
                            onClick={() =>
                              props.clearInvoiceHandler(data?.unique_id)
                            }
                            style={{
                              padding: "8px 16px",
                              backgroundColor: "#1814F3",
                              color: "white",
                              border: "none",
                              borderRadius: "5px",
                              cursor: "pointer",
                              fontSize: "14px",
                              fontWeight: "500",
                              transition: "all 0.2s ease",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                              width: "auto",
                            }}
                          >
                            Clear Invoice
                          </button>
                        )}
                    </div>
                  )}

                  {data?.product?.product_type ? (
                    <div
                      onClick={() =>
                        props.downloadPolicyHandler(data?.plate_no)
                      }
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1_1977)">
                          <path
                            d="M13 10H18L12 16L6 10H11V3H13V10ZM4 19H20V12H22V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V12H4V19Z"
                            fill="#3E414C"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1_1977">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>

                <div>
                  {props?.table_type === "customers" ? (
                    <div></div>
                  ) : (
                    <div>
                      {data?.details?.map((pin, index) => (
                        <div key={index}>
                          <p>
                            Pin {`(${index + 1})`}: {pin?.pin}
                          </p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <p>{`${data?.product?.product_type || ""} ${
                  data?.product?.product_type ? "-" : ""
                } ${data?.product?.product_name || ""}`}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default DistributorTable;
